import { MagikAuth } from "./magik";
export default MagikAuth;